<template>
  <div class="c-ring-overlay-card l-flex l-flex--column">
    <a
      v-if="url"
      :href="url"
    >
      <div class="c-ring-overlay-card__container">
        <nuxt-img
          v-if="backgroundImage.src"
          class="c-ring-overlay-card__image"
          v-bind="$getImgOptions(backgroundImage, bgOptions)"
        />
        <nuxt-img
          v-if="overlayImage.src"
          class="c-ring-overlay-card__overlay-image"
          v-bind="$getImgOptions(overlayImage)"
        />
      </div>
    </a>
    <template v-else>
      <div class="c-ring-overlay-card__container">
        <nuxt-img
          v-if="backgroundImage.src"
          class="c-ring-overlay-card__image"
          v-bind="$getImgOptions(backgroundImage, bgOptions)"
        />
        <nuxt-img
          v-if="overlayImage.src"
          class="c-ring-overlay-card__overlay-image"
          v-bind="$getImgOptions(overlayImage)"
        />
      </div>
    </template>
    <btn
      v-if="cta"
      v-bind="cta"
      :aria-label="cta.text"
      button-size="large"
    >
      {{ cta.text }}
    </btn>
  </div>
</template>

<script>
import Btn from "../button/Btn";
import { UrlFilters } from '@mixins/cdnMixins'
export default {
  components: {
    Btn,
  },
  mixins: [ UrlFilters ],
  props: {
    backgroundImage: {
      type: Object,
      default: () => {},
    },
    overlayImage: {
      type: Object,
      default: () => {},
    },
    cta: {
      type: Object,
      default: () => {},
    },
    url: {
      type: String,
      default: "",
    }
  },
  computed: {
    bgOptions() {
      return { width: 310 }
    }
  }
};
</script>

<style lang="scss" scoped>
.c-ring-overlay-card {
  width: rem(310px);
  margin-right: rem(10px);
  &__container {
    position: relative;
    height: 100%;
    height: rem(365px);
    width: rem(310px);
  }
  &__image {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  &__overlay-image {
    position: absolute;
    height: rem(120px);
    bottom: rem(20px);
    left: rem(0px);
  }
}
</style>
